"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledClearFix = void 0;
var _ClearFix = require("./ClearFix");
var StyledClearFix = _ClearFix.ClearFix;
exports.StyledClearFix = StyledClearFix;